export function tagIndexRequest(projectId) {
  return {
    type: '@tags/INDEX_REQUEST',
    payload: { projectId },
  };
}

export function tagIndexSuccess(data) {
  return {
    type: '@tags/INDEX_SUCCESS',
    payload: { data },
  };
}

export function tagIndexFailure() {
  return {
    type: '@tags/INDEX_FAILURE',
  };
}

export function tagUpdateRequest(projectId, id, data, onDone) {
  return {
    type: '@tags/UPDATE_REQUEST',
    payload: { projectId, id, data, onDone },
  };
}

export function tagDeleteRequest(projectId, id, onDone) {
  return {
    type: '@tags/DELETE_REQUEST',
    payload: { projectId, id, onDone },
  };
}

export function tagSaveFinish() {
  return {
    type: '@tags/SAVE_FINISH',
  };
}

export function tagCreateRequest(projectId, data, onCreated) {
  return {
    type: '@tags/CREATE_REQUEST',
    payload: { projectId, data, onCreated },
  };
}

export function tagCreateSuccess() {
  return {
    type: '@tags/CREATE_SUCCESS',
  };
}

export function tagCreateFailure() {
  return {
    type: '@tags/CREATE_FAILURE',
  };
}
